import React from 'react';
import NavBar from '../../NavBar';
import SectionHead from '../../Groups/SectionHead';
import Hr from '../../SVGs/Hr';
import "./Resume.css"

export default function Resume() {
  return (
    <>
      <NavBar />
      <div style={{ textAlign: 'center', paddingTop: '50px' }}>
        <SectionHead text="😎Resume😎" />
        <Hr />

        {/* Styled iframe */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '20px 0',
            padding: '0 20px', // Add some padding for small screens
          }}
        >
          <iframe
            src="/resume.pdf"
            title="Resume"
            style={{
              width: '100%',
              height: '600px',
              maxWidth: '100%', // Ensures it doesn't exceed screen width
              border: '2px solid #ddd',
              borderRadius: '10px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              padding: '10px',
              objectFit: 'contain', // Ensures proper scaling
            }}
          ></iframe>
        </div>

        {/* Download button with black and white styling */}
        <a href="/resume.pdf" download>
          <button
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#000',
              color: '#fff',
              borderTop: '5px solid #000',
              cursor: 'pointer',
              transition: '0.3s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#fff';
              e.target.style.color = '#000';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#000';
              e.target.style.color = '#fff';
            }}
          >
            Download Resume
          </button>
        </a>
      </div>
    </>
  );
}
